/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Tag_RecognitionInputs */

const en_resume_tag_recognition = /** @type {(inputs: Resume_Tag_RecognitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recognition`)
};

const ar_resume_tag_recognition = /** @type {(inputs: Resume_Tag_RecognitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكريم`)
};

const bn_resume_tag_recognition = /** @type {(inputs: Resume_Tag_RecognitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অর্জন`)
};

const de_resume_tag_recognition = /** @type {(inputs: Resume_Tag_RecognitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anerkennung`)
};

const es_resume_tag_recognition = /** @type {(inputs: Resume_Tag_RecognitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconocimiento`)
};

const fr_resume_tag_recognition = /** @type {(inputs: Resume_Tag_RecognitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnaissance`)
};

const pt_resume_tag_recognition = /** @type {(inputs: Resume_Tag_RecognitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconhecimento`)
};

const zh_resume_tag_recognition = /** @type {(inputs: Resume_Tag_RecognitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认可`)
};

const tr_resume_tag_recognition = /** @type {(inputs: Resume_Tag_RecognitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanınma`)
};

const ru_resume_tag_recognition = /** @type {(inputs: Resume_Tag_RecognitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Признание`)
};

const pl_resume_tag_recognition = /** @type {(inputs: Resume_Tag_RecognitionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uznanie`)
};

/**
* | output |
* | --- |
* | "Recognition" |
*
* @param {Resume_Tag_RecognitionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_tag_recognition = /** @type {((inputs?: Resume_Tag_RecognitionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Tag_RecognitionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_tag_recognition(inputs)
	if (locale === "bn") return bn_resume_tag_recognition(inputs)
	if (locale === "de") return de_resume_tag_recognition(inputs)
	if (locale === "es") return es_resume_tag_recognition(inputs)
	if (locale === "fr") return fr_resume_tag_recognition(inputs)
	if (locale === "pt") return pt_resume_tag_recognition(inputs)
	if (locale === "zh") return zh_resume_tag_recognition(inputs)
	if (locale === "tr") return tr_resume_tag_recognition(inputs)
	if (locale === "ru") return ru_resume_tag_recognition(inputs)
	if (locale === "pl") return pl_resume_tag_recognition(inputs)
	return en_resume_tag_recognition(inputs)
});